import { IApiError } from '@/models/apiError.model';
import { ICashRegister } from '@/models/financialSettings.model';
import { IPagination } from '@/models/pagination.model';

export const FINANCIAL_SETTINGS_SLICE_NAME = 'financialSettings';

export interface FinancialSettingsState {
  cashRegisters: {
    data: ICashRegister[];
    meta: IPagination;
  } | null;
  cashRegister: ICashRegister | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: FinancialSettingsState = {
  cashRegisters: null,
  cashRegister: null,
  isLoading: false,
  error: null,
};
